export default "__VITE_ASSET__73cfd89e__"